export const loadsSourcingPageStateKey = 'loads-sourcing-page';
import { CarrierDTOResponse } from 'cargo-chief-commons';
import { LOAD_TYPES } from '../constants/load-type';

export interface LoadsSourcingState {
	accountId: number;
	accountLogoUrl: string;
	businessName: string;
	carrier: CarrierDTOResponse;
	carrierId: string;
	carrierMc: string;
	carrierDot: string;
	currentPage: number;
	error: string;
	filters: any[];
	loading: boolean;
	loadsList: any[];
	loadsListCopy: any[];
	successfulLoads: any[];
	unsuccessfulLoads: any[];
	currentRateSelection: number;
	offerSubmitted: boolean;
	offerDialogOpen: boolean;
	pageSize: number;
	sort: any[];
	total: number;
	equipment: string;
	originState: string;
	batchId: string;
	companyList: any;
	loadType: string;
	showOpenLoads: boolean;
	countOfBidsBeingAdded: number;
	isDeclineOfferRequestInProgress: boolean;
	apiMessage: string | null;
}

export const initialState: LoadsSourcingState = {
	accountId: null,
	accountLogoUrl: null,
	businessName: null,
	carrier: null,
	carrierId: null,
	carrierMc: null,
	carrierDot: null,
	currentPage: 0,
	error: null,
	filters: [],
	loading: true,
	loadsList: [],
	loadsListCopy: [],
	successfulLoads: [],
	unsuccessfulLoads: [],
	currentRateSelection: null,
	offerSubmitted: false,
	offerDialogOpen: false,
	pageSize: 25,
	sort: [],
	total: 0,
	equipment: null,
	originState: null,
	batchId: null,
	companyList: [],
	loadType: LOAD_TYPES.MATCHED_LOADS,
	showOpenLoads: false,
	countOfBidsBeingAdded: 0,
	isDeclineOfferRequestInProgress: false,
	apiMessage: null,
};
